import jsPDF from "jspdf";
import html2canvas from "html2canvas";

// Renders a DOM node to a paginated A4 PDF and triggers download.
export async function exportRetirementPdf(node, { title = "Retirement Plan", subtitle = "" } = {}) {
  if (!node) throw new Error("Nothing to export");

  const canvas = await html2canvas(node, {
    scale: 2,
    backgroundColor: "#0d1524",
    useCORS: true,
    logging: false,
  });

  const pdf = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();
  const margin = 32;
  const headerH = 64;

  // Header
  pdf.setFillColor(13, 21, 36);
  pdf.rect(0, 0, pageW, pageH, "F");
  pdf.setTextColor(255, 255, 255);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(18);
  pdf.text(title, margin, 40);
  if (subtitle) {
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(11);
    pdf.setTextColor(150, 160, 180);
    pdf.text(subtitle, margin, 56);
  }

  const contentW = pageW - margin * 2;
  const imgH = (canvas.height * contentW) / canvas.width;
  const availFirst = pageH - headerH - margin;

  if (imgH <= availFirst) {
    pdf.addImage(canvas.toDataURL("image/png"), "PNG", margin, headerH, contentW, imgH);
  } else {
    // Slice the tall canvas into page-height chunks
    const pxPerPt = canvas.width / contentW;
    let renderedPt = 0;
    let first = true;
    while (renderedPt < imgH) {
      const availPt = first ? availFirst : pageH - margin * 2;
      const sliceHpx = Math.min(canvas.height - renderedPt * pxPerPt, availPt * pxPerPt);
      const slice = document.createElement("canvas");
      slice.width = canvas.width;
      slice.height = sliceHpx;
      slice.getContext("2d").drawImage(canvas, 0, renderedPt * pxPerPt, canvas.width, sliceHpx, 0, 0, canvas.width, sliceHpx);
      const sliceHpt = sliceHpx / pxPerPt;
      const y = first ? headerH : margin;
      if (!first) { pdf.addPage(); pdf.setFillColor(13, 21, 36); pdf.rect(0, 0, pageW, pageH, "F"); }
      pdf.addImage(slice.toDataURL("image/png"), "PNG", margin, y, contentW, sliceHpt);
      renderedPt += sliceHpt;
      first = false;
    }
  }

  pdf.save(`${title.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}.pdf`);
}
